import { useEffect } from "react";
import { enableActivityTracking, trackPageView, } from "@snowplow/browser-tracker";
import { globalTrackerName } from "./config";
export var useSnowplowPageTracking = function (props) {
    var isEnabled = props.isEnabled, title = props.title, userUpdated = props.userUpdated;
    useEffect(function () {
        if (!isEnabled)
            return;
        if (userUpdated) {
            enableActivityTracking({ heartbeatDelay: 10, minimumVisitLength: 30 });
            trackPageView({
                title: title,
            }, [globalTrackerName]);
        }
    }, [isEnabled, title, userUpdated]);
};
